import React, { useContext, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

import PsContext from "../../../context/PsContext";
import MobileMenuLink from "./mobileMenuLink";
import TopSearchBar from "./topSearchBar";
import CartLink from "./cartLink";
import LOGO from "../../../assets/img/shibani-logoo.png";
import { Modal } from "react-bootstrap";
import LoginForm from "../../pages/userAccount/loginForm";
import toast from "react-hot-toast";

const Header = () => {
  const context = useContext(PsContext);
  const [show, showModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogoutClick = () => {
    toast(
      (t) => (
        <span>
          Are you sure you want to log out?
          <div
            style={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
                context.userLogout();
              }}
              style={{
                padding: "4px 8px",
                background: "#d33",
                color: "white",
                border: "none",
              }}
            >
              Yes
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{ padding: "4px 8px", background: "#ccc", border: "none" }}
            >
              No
            </button>
          </div>
        </span>
      ),
      { duration: 10000 }
    );
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header id="top-header1" style={{ marginBottom: "15px" }}>
        <div className="main-header">
          <div className="container-full px_15 lg-px_40">
            <div className="row my-1 wrapper-header logo-area justify-content-center align-items-center">
              <div className="col-xl-4 col-md-4 col-6 text-center tf-lg-hidden">
                <MobileMenuLink />
              </div>
              <div className="col-xl-4 col-md-4 col-6 text-center tf-md-hidden">
                <TopSearchBar />
              </div>
              <div className="col-xl-4 col-md-4 col-6 text-center d-flex justify-content-center">
                <Link to="/">
                  <img
                    src={LOGO}
                    alt="Logo"
                    style={{ width: "210px" }}
                    className="logo mob-img"
                  />
                </Link>
              </div>

              <div className="col-xl-4 col-md-4 col-3 d-flex justify-content-end mob-icons">
                <ul className="nav-icon gap-20">
                  <li
                    className="position-relative mob-profile"
                    ref={dropdownRef}
                  >
                    {context.state.userLogged === "yes" ? (
                      <>
                        <a
                          href="#"
                          className="nav-link nav-link-sm has-icon my-menu-1 text-white"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowDropdown(!showDropdown);
                          }}
                          style={{
                            fontSize: "12px",
                            backgroundColor: "rgb(245 139 118)",
                            padding: "2px 8px",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "3px",
                          }}
                        >
                          <i
                            className="icon icon-account me-2 fs-13"
                            style={{ fontSize: "11px" }}
                          ></i>
                          <span className="me-2">My Profile</span>
                          <i class="fas fa-chevron-down"></i>
                        </a>

                        {showDropdown && (
                          <ul
                            className="dropdown-menu show mob-drop"
                            style={{
                              display: "block",
                              position: "absolute",
                              top: "-24px",
                              right: 0,
                              zIndex: 9999,
                              backgroundColor: "#fff",
                              borderRadius: "6px",
                              boxShadow: "0px 0px 10px rgba(0,0,0,0.15)",
                              padding: "0.5rem",
                              width: "100%",
                            }}
                          >
                            <li className="list-sty">
                              <Link
                                className="dropdown-item fs-13"
                                to="/user/my-profile"
                              >
                                <i className="icon icon-account me-2 fs-13 text-primary" />{" "}
                                My Profile
                              </Link>
                            </li>
                            <li className="list-sty">
                              <Link
                                className="dropdown-item fs-13"
                                to="/user/my-orders"
                              >
                                <i className="icon icon-bag me-2 fs-13 text-primary" />{" "}
                                Orders
                              </Link>
                            </li>
                            <li className="list-sty">
                              <Link
                                className="dropdown-item fs-13"
                                to="/wishlist"
                              >
                                <i className="icon icon-heart me-2 fs-13 text-primary" />{" "}
                                Wishlist
                              </Link>
                            </li>
                            <li className="list-sty">
                              <Link
                                className="dropdown-item fs-13"
                                to="/viewcart"
                              >
                                <i className="fas fa-shopping-cart me-2 fs-13 text-primary" />{" "}
                                View Cart
                              </Link>
                            </li>
                            {/*<li className="list-sty">
                              <Link
                                className="dropdown-item fs-13"
                                to="/coupons"
                              >
                                <i className="icon icon-ticket me-2" /> Coupons
                              </Link>
                            </li> */}
                            <li>
                              <button
                                className="dropdown-item fs-13"
                                onClick={handleLogoutClick}
                              >
                                <i className="fa fa-sign-out-alt me-2 fs-13 text-primary" />{" "}
                                Logout
                              </button>
                            </li>
                          </ul>
                        )}
                      </>
                    ) : (
                      <>
                        <a
                          href="javascript:;"
                          className="nav-link-sm has-icon my-menu-1 my-menu11"
                          onClick={() => showModal(true)}
                          style={{
                            fontSize: "12px",
                            backgroundColor: "rgb(245 139 118)",
                            padding: "2px 8px",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "3px",
                          }}
                        >
                          <i
                            className="icon icon-account me-2"
                            style={{ fontSize: "11px" }}
                          ></i>
                          Sign In
                        </a>

                        <Modal
                          show={show}
                          onHide={() => showModal(false)}
                          backdrop="static"
                        >
                          <Modal.Header closeButton>
                            Sign In / Sign Up
                          </Modal.Header>
                          <Modal.Body>
                            <LoginForm afterFinish={() => showModal(false)} />
                          </Modal.Body>
                        </Modal>
                      </>
                    )}
                  </li>
                  <CartLink />
                </ul>
              </div>

              <div className="col-xl-2 md-6 tf-lg-hidden mob-search">
                <TopSearchBar />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
